var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notepad_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 12)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID__XE7wcyLqYisWKufxCDQLa_6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 24,
    y1: 35.934,
    x2: 24,
    y2: 41.432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "43.5%",
    style: {
      stopColor: "rgb(56,32,16)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(176,98,43)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID__XE7wcyLqYisWKufxCDQLa_6)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -36)",
    d: "M 37 43 L 11 43 C 9.895 43 9 42.105 9 41 L 9 29 L 39 29 L 39 41 C 39 42.105 38.105 43 37 43 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 9.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID__XE7wcyLqYisWKufxCDQLb_7",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 24,
    y1: 33.455,
    x2: 24,
    y2: 38.561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "44.1%",
    style: {
      stopColor: "rgb(153,153,152)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65.3%",
    style: {
      stopColor: "rgb(193,193,192)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(229,229,229)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(243,243,243)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID__XE7wcyLqYisWKufxCDQLb_7)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -33.5)",
    d: "M 37 40 L 11 40 C 9.895 40 9 39.105 9 38 L 9 27 L 39 27 L 39 38 C 39 39.105 38.105 40 37 40 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -2.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID__XE7wcyLqYisWKufxCDQLc_8",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 9.499,
    y1: 6.118,
    x2: 37.735,
    y2: 36.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(125,216,243)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(69,176,208)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID__XE7wcyLqYisWKufxCDQLc_8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -21.5)",
    d: "M 37 37 L 11 37 C 9.895 37 9 36.105 9 35 L 9 8 C 9 6.895 9.895 6 11 6 L 37 6 C 38.105 6 39 6.895 39 8 L 39 35 C 39 36.105 38.105 37 37 37 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -17.5)",
    d: "M 34.5 19 L 13.5 19 C 13.224 19 13 18.776 13 18.5 L 13 16.5 C 13 16.224 13.224 16 13.5 16 L 34.5 16 C 34.776 16 35 16.224 35 16.5 L 35 18.5 C 35 18.776 34.776 19 34.5 19 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -23.5)",
    d: "M 34.5 25 L 13.5 25 C 13.224 25 13 24.776 13 24.5 L 13 22.5 C 13 22.224 13.224 22 13.5 22 L 34.5 22 C 34.776 22 35 22.224 35 22.5 L 35 24.5 C 35 24.776 34.776 25 34.5 25 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -29.5)",
    d: "M 34.5 31 L 13.5 31 C 13.224 31 13 30.776 13 30.5 L 13 28.5 C 13 28.224 13.224 28 13.5 28 L 34.5 28 C 34.776 28 35 28.224 35 28.5 L 35 30.5 C 35 30.776 34.776 31 34.5 31 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-34.5, -6.5)",
    d: "M 34.5 9 L 34.5 9 C 33.672 9 33 8.328 33 7.5 L 33 5.5 C 33 4.672 33.672 4 34.5 4 L 34.5 4 C 35.328 4 36 4.672 36 5.5 L 36 7.5 C 36 8.328 35.328 9 34.5 9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.5 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-27.5, -6.5)",
    d: "M 27.5 9 L 27.5 9 C 26.672 9 26 8.328 26 7.5 L 26 5.5 C 26 4.672 26.672 4 27.5 4 L 27.5 4 C 28.328 4 29 4.672 29 5.5 L 29 7.5 C 29 8.328 28.328 9 27.5 9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.5 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20.5, -6.5)",
    d: "M 20.5 9 L 20.5 9 C 19.672 9 19 8.328 19 7.5 L 19 5.5 C 19 4.672 19.672 4 20.5 4 L 20.5 4 C 21.328 4 22 4.672 22 5.5 L 22 7.5 C 22 8.328 21.328 9 20.5 9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.5 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,112,147)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-13.5, -6.5)",
    d: "M 13.5 9 L 13.5 9 C 12.672 9 12 8.328 12 7.5 L 12 5.5 C 12 4.672 12.672 4 13.5 4 L 13.5 4 C 14.328 4 15 4.672 15 5.5 L 15 7.5 C 15 8.328 14.328 9 13.5 9 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.6205f95b14e69c6da39b5877d3ad2abc.svg";
export { ForwardRef as ReactComponent };